import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { metricDataPropType } from '../Utils/types'

// CRV is a percentage value but kept as a number for type safety
const formatValue = (value, isCVR) => {
  if (isCVR) {
    return `${value}%`
  }

  return value
}

export default function DailySummary({ label, data }) {
  const { value } = data
  const isCVR = label?.toLowerCase() === 'cvr'

  return (
    <Box
      sx={{
        p: 2,
      }}
    >
      <Typography variant="h4" fontWeight="bold">
        {formatValue(value, isCVR)}
      </Typography>
      {label}
    </Box>
  )
}

DailySummary.propTypes = {
  label: PropTypes.string.isRequired,
  data: metricDataPropType.isRequired,
}
